import type { StoredGroup } from '~/gql/groups/groups'
import { MoreHorizontal } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~/components/ui/dropdown-menu'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '~/components/ui/table'
import { tourAnchor } from '~/helpers/tour/anchors'

/** Le tableau des groupes, avec le menu d'actions de chaque ligne. */
export default function GroupsList({ groups, onEdit, onDelete }: {
  groups: StoredGroup[]
  onEdit: (group: StoredGroup) => void
  onDelete: (group: StoredGroup) => void
}) {
  const { t } = useTranslation()

  return (
    <Table aria-label={t('common.routing.groups')}>
      <TableHeader>
        <TableRow>
          <TableHead>{t('common.name')}</TableHead>
          <TableHead>{t('common.description')}</TableHead>
          <TableHead>{t('groups.memberCount')}</TableHead>
          <TableHead className="w-[80px] text-right">{t('common.action')}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {groups.map(group => (
          <TableRow key={group.id}>
            <TableCell className="font-medium">{group.name}</TableCell>
            <TableCell className="text-muted-foreground">
              {group.description || '—'}
            </TableCell>
            <TableCell>{group.memberCount}</TableCell>
            <TableCell className="text-right">
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost" className="size-8 p-0" {...tourAnchor('groups.actions')}>
                    <span className="sr-only">{t('common.actionFor', { action: t('common.action'), name: group.name })}</span>
                    <MoreHorizontal className="size-4" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                  <DropdownMenuItem onClick={() => onEdit(group)}>
                    {t('common.update')}
                  </DropdownMenuItem>
                  <DropdownMenuItem
                    className="text-destructive focus:text-destructive"
                    onClick={() => onDelete(group)}
                  >
                    {t('common.delete')}
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
